import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

import { useOnlineUsersList } from '@/store';

type Props = {
  userId: string;
};

export const IsUserOnline: React.FC<Props> = ({ userId }) => {
  const { isUserOnline } = useOnlineUsersList();
  const isOnline = isUserOnline(userId);
  const { t } = useTranslation();

  return (
    <Tooltip title={t('ONLINE_TOOLTIP')} trigger="hover" placement="top">
      <Icon i="DotMark" color={isOnline ? 'green6' : 'black4'} />
    </Tooltip>
  );
};
